import React, { CSSProperties } from 'react';

const FlexSep = (p: {
  className?: string;
  style?: CSSProperties;
  grow?: boolean;
}) => {
  return (
    <div
      className={p.className}
      style={{
        ...p.style,
        ...(p.grow
          ? { flexGrow: 1, flexShrink: 1 }
          : { flexBasis: '1rem', flexGrow: 0, flexShrink: 0 }),
      }}
    />
  );
};

export default FlexSep;
